import React from 'react';

// value is the slug
const CheckboxGroup = ({
  name,
  selectedCheckboxes,
  options,
  label = '',
  className,
  id,
  disabled,
  handleChange,
  placeholderMessage,
  validationMessage,
  validationError,
  alignLeft,
  mod,
}) => {
  const onChange = (e) => {
    if (handleChange instanceof Function) handleChange(e.target.value);
  };

  const getOptions = (options) => {
    return options.map((option) => {
      const { display, value: optionValue, id } = option;

      if (mod === 'destinations') {
        return (
          <div
            className="c-form__destination-group"
            key={`checkbox-group--${optionValue}`}
          >
            <label
              htmlFor={id}
              className={`c-form__checkbox u-mb-4 ${alignLeft ? 'u-ml-0' : ''}`}
            >
              <input
                id={id}
                value={optionValue}
                type="checkbox"
                name={optionValue}
                onClick={(e) => onChange(e)}
                onChange={(e) => onChange(e)}
                checked={selectedCheckboxes.includes(optionValue)}
              />
              <span dangerouslySetInnerHTML={{ __html: display }}></span>
            </label>

            <div className="c-form__destination-group__child-destinations">
              {option.regions.map(({ display, value: optionValue }) => (
                <label
                  htmlFor={id}
                  className={`c-form__checkbox u-mb-4 ${
                    alignLeft ? 'u-ml-0' : ''
                  }`}
                  key={`checkbox--${optionValue}`}
                >
                  <input
                    id={id}
                    value={optionValue}
                    type="checkbox"
                    name={optionValue}
                    onClick={(e) => onChange(e)}
                    onChange={(e) => onChange(e)}
                    checked={selectedCheckboxes.includes(optionValue)}
                  />
                  <span dangerouslySetInnerHTML={{ __html: display }}></span>
                </label>
              ))}
            </div>
          </div>
        );
      } else {
        return (
          <label
            htmlFor={id}
            className={`c-form__checkbox u-mb-4 ${alignLeft ? 'u-ml-0' : ''}`}
            key={`checkbox--${optionValue}`}
          >
            <input
              id={id}
              value={optionValue}
              type="checkbox"
              name={optionValue}
              onClick={(e) => onChange(e)}
              onChange={(e) => onChange(e)}
              checked={selectedCheckboxes.includes(optionValue)}
            />
            <span dangerouslySetInnerHTML={{ __html: display }}></span>
          </label>
        );
      }
    });
  };

  return (
    <>
      <label
        className={`u-weight--semibold ${
          !label.length && label.length < 1 ? 'u-hidden' : ''
        }`}
        htmlFor={name}
      >
        {label || name}
      </label>

      {getOptions(options)}

      {validationError && (
        <p className="c-form__error u-weight--semibold u-mb-0">
          {validationMessage}
        </p>
      )}
    </>
  );
};

export default CheckboxGroup;
